import { fabric } from 'fabric';

import {
  hasShapeMeasureLabel,
  isBacksplashMeasureLabel,
  isCornerRadiusArc,
  isDiagonalCorner,
  isShapeEdge,
  isShapeLabel,
} from '~/core/utils';
import theme from '~/theme/theme';

const {
  drawingTool: {
    drawingShape: { stroke },
    secondaryBorderColor,
  },
} = theme.light;

export const setActiveShapeNameAndColors = (item: fabric.Object) => {
  item.set({ stroke: stroke.active });
  if (isShapeLabel(item)) {
    item.set({ fill: stroke.active });
  }

  if (hasShapeMeasureLabel(item)) {
    item.name = item.data.rawText;
  }

  if (isBacksplashMeasureLabel(item)) {
    item.name = item.data.rawText;
  }

  // change edge stroke color
  if (isShapeEdge(item)) {
    item.set({ stroke: secondaryBorderColor });
  }

  // change corner radii arc stroke color  // doesn't currently work without parentName which causes arc to fill
  if (isCornerRadiusArc(item)) {
    item.set({ stroke: secondaryBorderColor });
  }

  // change corner diagonal stroke color
  if (isDiagonalCorner(item)) {
    item.set({ stroke: secondaryBorderColor });
  }
};
